import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { isPaymentMethodMissing } from '~/utils/payment-gate';

/**
 * Gate for placing orders on accounts without a card on file.
 * `isCardMissing` reflects the account; `isGateOpen` controls the "add a card" modal.
 */
const useOrderPaymentGate = () => {
  const isCardMissing = useSelector((state) => isPaymentMethodMissing(state.userReducers.user));
  const [isGateOpen, setIsGateOpen] = useState(false);

  const openGate = useCallback(() => setIsGateOpen(true), []);
  const closeGate = useCallback(() => setIsGateOpen(false), []);

  return { isCardMissing, isGateOpen, openGate, closeGate };
};

export default useOrderPaymentGate;
